import { render, staticRenderFns } from "./levantamentosSidebar.vue?vue&type=template&id=e4dac1e0"
import script from "./levantamentosSidebar.vue?vue&type=script&lang=js"
export * from "./levantamentosSidebar.vue?vue&type=script&lang=js"
import style0 from "./levantamentosSidebar.vue?vue&type=style&index=0&id=e4dac1e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports